// extracted by mini-css-extract-plugin
export var readonly = "_h1-1";
export var star = "_h1-0";